import React, { FunctionComponent, lazy, Suspense } from 'react'

import { Theme, useTheme } from '../Theme'
import styles from './style.module.scss'

interface Props {
  size?: string
}

const CashSpinner = lazy(async () => import('./CashSpinner'))
const PegasusSpinner = lazy(async () => import('./PegasusSpinner'))

export const Spinner: FunctionComponent<Props> = ({ size = '56' }) => {
  const {
    theme: { selected },
  } = useTheme()

  const fallback = <div data-testid='loading-icon-svg' className={styles.spinner}></div>

  if (selected === Theme.Cash) {
    return (
      <Suspense fallback={fallback}>
        <CashSpinner size={size} />
      </Suspense>
    )
  }

  if (selected === Theme.Pegasus || selected === Theme.Kelpie || selected === Theme.KelpieMint) {
    return (
      <Suspense fallback={fallback}>
        <PegasusSpinner size={size} />
      </Suspense>
    )
  }

  return fallback
}
